module.exports = __webpack_public_path__ + "fonts/montserrat-extraBold.69542103c5dd6cd037bea90bfe130577.woff2";